import React from 'react';
import {AuthConsumer} from '../../../providers/AuthProvider';

import '../../../index.scss';
import NewPageLoader from '../../page-loader/NewPageLoader';

export const SilentRenew = () => (
  <AuthConsumer>
    {({signinSilentCallback}) => {
      signinSilentCallback();
      return (
        <div className="loading-page-container">
          <NewPageLoader />
        </div>
      );
    }}
  </AuthConsumer>
);
